module.exports = __webpack_public_path__ + "img/M4_JKKP_16.d07d384e.png";